import { render, staticRenderFns } from "./ListMutation.vue?vue&type=template&id=2da93d14&"
import script from "./ListMutation.vue?vue&type=script&lang=js&"
export * from "./ListMutation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports